export default "__VITE_ASSET__395d4cce__"